import {MailItemContentType} from "../../Types/MailItemTypes";
import {InForwardingBatchInfo} from "./Components/InForwardingBatchInfo";
import {MailItemContents} from "./Components/MailItemContents";
import {MailItemMeta} from "./Components/MailItemMeta";

const MailItemContent = (props: MailItemContentType) => {
    return (
        <div className={'row'}>
            <div className={'col-xs-12 col-lg-4 col-xl-3'}>
                <MailItemMeta mailboxTopBarHeight={props.mailboxTopBarHeight}/>
            </div>
            <div className={'col-xs-12 col-lg-8 col-xl-9'}>
                <InForwardingBatchInfo />
                <MailItemContents />
            </div>
        </div>
    )
}

export { MailItemContent }
